import { h, Component, Fragment } from 'preact';
import mapService from './../services/map.service';

export default class MapComponent extends Component {
    componentDidMount() {
        mapService.initializeMap(this.mapElement);
    }

    render() {
        const self = this;
        return (
            <Fragment>
                <main class="map" id="tsunami-map" ref={m => {
                    self.mapElement = m;
                }}></main>
            </Fragment>
        );
    }
}
